import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { toast } from 'react-toastify';
import { Form, Row, Col } from 'react-bootstrap';
import { FormLayout, FormSection, FormField } from '../../shared/ui/FormLayout';

const CreateCategoryOfNewsPage = () => {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ title: '', description: '' });

  const handleSubmit = async () => {
    if (!form.title.trim()) { toast.error('Введите название'); return; }
    setSaving(true);
    try {
      await apiRequests.news.createCategory(form);
      toast.success('Категория создана');
      navigate('/news/categories');
    } catch { toast.error('Ошибка'); } finally { setSaving(false); }
  };

  return (
    <FormLayout onSubmit={handleSubmit} onBack={() => navigate('/news/categories')} saving={saving} submitText="Создать">
      <FormSection title="Основная информация">
        <Row>
          <Col md={6}>
            <FormField label="Название" required>
              <Form.Control type="text" value={form.title} onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))} placeholder="Категория" />
            </FormField>
          </Col>
          <Col md={6}>
            <FormField label="Описание">
              <Form.Control type="text" value={form.description} onChange={(e) => setForm((prev) => ({ ...prev, description: e.target.value }))} placeholder="Описание" />
            </FormField>
          </Col>
        </Row>
      </FormSection>
    </FormLayout>
  );
};

export default CreateCategoryOfNewsPage;
